document.addEventListener("DOMContentLoaded", function () {

  const radios = document.querySelectorAll('input[name="contact[variant]"]');
  const priceBox = document.querySelector(".price");
  const priceWrapper = document.querySelector(".pricenew");

  radios.forEach(radio => {
    radio.addEventListener("change", function () {

      const price = this.getAttribute("data-variant-price");

      if (priceBox) {
        priceBox.textContent = price;
      }

      if (priceWrapper) {
        priceWrapper.style.display = "inline"; // or "block"
      }

    });
  });

});
document.addEventListener("DOMContentLoaded", function () {
  const dateInput = document.getElementById("deliveryDate");

  const today = new Date().toISOString().split("T")[0];
  dateInput.setAttribute("min", today);
});
document.addEventListener("DOMContentLoaded", function () {
  const fileInput = document.getElementById("logoInput");
  const successMsg = document.getElementById("successMsg");
  const uploadText = document.getElementById("uploadText");
  const browseBtn = document.getElementById("browseBtn");

  // Open file picker when button clicked
  browseBtn.addEventListener("click", () => {
    fileInput.click();
  });

  // When file is selected
  fileInput.addEventListener("change", function () {
    if (this.files.length > 0) {
      const fileName = this.files[0].name;

      uploadText.textContent = fileName; // show file name
      successMsg.style.display = "block"; // show success message
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {

  const form = document.getElementById("quoteForm");

  form.addEventListener("submit", async function (e) {
    e.preventDefault();

    const selectedVariant = document.querySelector('input[name="contact[variant]"]:checked');

    if (!selectedVariant) {
      alert("Please select a variant");
      return;
    }

    const getValue = (selector) => {
      const el = form.querySelector(selector);
      return el ? el.value : "";
    };

    const name = getValue('[name="contact[name]"]');
    const email = getValue('[name="contact[email]"]');

    if (!name || !email) {
      alert("Name and email are required");
      return;
    }

    const formData = new FormData();

    formData.append("id", selectedVariant.value);
    formData.append("quantity", 1);

    formData.append("properties[name]", name);
    formData.append("properties[company]", getValue('[name="contact[company]"]'));
    formData.append("properties[email]", email);
    formData.append("properties[phone]", getValue('[name="contact[phone]"]'));
    formData.append("properties[business_type]", getValue('[name="contact[business_type]"]'));
    formData.append("properties[delivery_date]", getValue('[name="contact[delivery_date]"]'));
    formData.append("properties[extra]", getValue('[name="contact[extra]"]'));

    try {
      await fetch('/cart/clear.js', { method: 'POST' });

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!res.ok) throw new Error("Add to cart failed");

      const data = await res.json();
      console.log("Added to cart:", data);

      window.location.href = "/checkout";

    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    }

  });

});